var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({class:{
        teal: _vm.visible,
        red: !_vm.visible,
      },attrs:{"dark":""}},on),[_vm._v("\n      "+_vm._s(_vm.visible ? "Visible" : "No visible")+"\n    ")])]}}])},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.messages)}})])}
var staticRenderFns = []

export { render, staticRenderFns }